const eventTarget = new EventTarget();

export const dispatchLeaseChangeEvent = () => {
  eventTarget.dispatchEvent(new Event('leaseChange'));
};

export const addLeaseChangeListener = (callback: () => void) => {
  eventTarget.addEventListener('leaseChange', callback);
};

export const removeLeaseChangeListener = (callback: () => void) => {
  eventTarget.removeEventListener('leaseChange', callback);
};
